module.exports = __webpack_public_path__ + "accom-check.png";